export enum NotificationsPageUrlFragmentEnum {
  NEW = 'new',
  CLEARED = 'cleared'
}
